
























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import DataTable from "@/components/data/data-table.vue";
import { dashboardService } from "@/services/dash";
import { DataTableField, DataTableSort } from "@/components/data/data-table";
import moment, { Moment } from "moment";
import { watch } from "@vue/composition-api";
import OccupancyModal from "@/components/modals/occupancy.vue";
// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "kpi-table",
    components: { OccupancyModal, DataTable },
})
export default class KpiTable extends Vue {
    @Prop({ required: true })
    customerId: number;

    date: Moment = moment().startOf("day");
    datepickerOpen: boolean = false;

    loading: boolean = false;
    offices: any[] = [];
    sorting: DataTableSort<any> = {
        field: "name",
        direction: 1,
    };

    fields: DataTableField<any>[] = [
        {
            label: "Office",
            field: "name",
            sortable: true,
        },
        // Hidden until it makes sense, eg. when timeslots are introduced
        // {
        //     label: "Reservations",
        //     field: "reservationsCount",
        //     sortable: true,
        // },
        {
            label: "Check-in's",
            field: "checkinsCount",
            sortable: true,
        },
        {
            label: "Check-out's",
            field: "checkoutsCount",
            sortable: true,
        },
        {
            label: "Booked desks",
            field: "bookedDesksCount",
            sortable: true,
        },
        {
            label: "Free desks",
            field: "freeDesksCount",
            sortable: true,
        },
        {
            label: "Total desks",
            field: "desksCount",
            sortable: true,
        },
    ];

    get sortedOffices() {
        return this.offices.slice().sort((o1, o2) => {
            return o1[this.sorting.field] > o2[this.sorting.field] ? this.sorting.direction : -this.sorting.direction;
        });
    }

    async created() {
        await this.refreshData();
    }

    @Watch("date")
    async refreshData() {
        this.loading = true;

        this.offices = await dashboardService.getOffices({
            params: {
                customer: this.$context.customer.id,
                date: this.date.format(moment.HTML5_FMT.DATE),
            },
        });

        this.loading = false;
    }

    async updateSorting(sort: DataTableSort<any>) {
        this.sorting = sort;
    }

    setDate(val) {
        this.date = moment(val);
    }
}
